module.exports = __webpack_public_path__ + "img/Group 1032.5ed9b282.png";